module.exports = __webpack_public_path__ + "static/img/split_knowledge.3f0c866a.png";